import clsx from 'clsx';
import {
  ColorElderberry500,
  ColorNeutral0,
  ColorNeutral500,
} from '@hungryroot/tokens';
import styles from './Loading.module.css';

export enum DotColorVariant {
  ColorNeutral0 = 'ColorNeutral0',
  ColorNeutral500 = 'ColorNeutral500',
}

export type SizeVariant = 'small';

type LoadingVariant =
  | 'translucent'
  | 'opaque'
  | 'inline-button'
  | 'translucent-popover'
  | 'container';

interface Props {
  testid?: string;
  variant?: LoadingVariant;
  dotColor?: DotColorVariant;
  sizeVariant?: SizeVariant;
  className?: string;
}

const getClassName = (variant: LoadingVariant | undefined) => {
  switch (variant) {
    case 'translucent':
      return styles.translucent;
    case 'inline-button':
      return styles['inline-button'];
    case 'translucent-popover':
      return styles['translucent-popover'];
    case 'container':
      return styles['container-loading'];
    default:
      return styles.loading;
  }
};

const getFillColor = (dotColor?: DotColorVariant) => {
  switch (dotColor) {
    case DotColorVariant.ColorNeutral0:
      return ColorNeutral0;
    case DotColorVariant.ColorNeutral500:
      return ColorNeutral500;
    default:
      return ColorElderberry500;
  }
};

export function Loading(props: Props) {
  const { testid, variant, dotColor, sizeVariant, className } = props;

  const width = sizeVariant && sizeVariant === 'small' ? '40' : '48';

  return (
    <div
      className={clsx(getClassName(variant), className)}
      data-testid={testid}
    >
      <svg
        width={width}
        height="32"
        viewBox="0 0 48 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="Loading">
          <circle
            className={styles.first}
            id="Dot1"
            cx="8"
            cy="16"
            r="4"
            fill={getFillColor(dotColor)}
          />
          <circle
            className={styles.second}
            id="Dot2"
            cx="24"
            cy="16"
            r="4"
            fill={getFillColor(dotColor)}
          />
          <circle
            className={styles.third}
            id="Dot3"
            cx="40"
            cy="16"
            r="4"
            fill={getFillColor(dotColor)}
          />
        </g>
      </svg>
    </div>
  );
}
